import cusIndex from "./newWork.vue"
let a = Object.assign({cusIndex})
export default a;